import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'connected-react-router';
import { Grid, Paper, Typography, Button } from '@mui/material';
import NetworkLockedIcon from '@mui/icons-material/NetworkLocked';

export class AgeGatePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      denied: false
    }

    this.handleAccept = this.handleAccept.bind(this);
  }

  handleAccept() {
    const { navigateTo, location } = this.props;

    localStorage.setItem('age_verification', true);
    navigateTo(location.pathname + location.search);
  }

  render() {
    const { promotion } = this.props;

    return (
      <React.Fragment>
        <div className="promo-banner background" role="img" title={promotion.banner_background_alt_text || "Promo banner background"} style={{'backgroundImage': 'url("' + promotion.banner_background + '")'}}></div>
        <Grid className="form-grid" size={{xs: 10, md: 5}} justifyContent="center">
          <Paper className="form-container" elevation={1}>
            <center><NetworkLockedIcon color="primary" style={{fontSize: 100}} /></center>
            <Typography variant="h4" align="center" paragraph>You must be over a certain age to view this content</Typography>

            {this.state.denied ?
              <Typography variant="h6" align="center">Unfortunately you can't view this content at this time</Typography>
            :
              <React.Fragment>
                <Typography variant="h6" align="center">Are you over {promotion.age_requirement} years of age?</Typography>

                <div style={{textAlign: 'center', paddingTop: '2em'}}>
                  <Button variant="contained" size="large" style={{marginRight: '3em'}} onClick={this.handleAccept}>Yes</Button>
                  <Button variant="contained" size="large" onClick={() => this.setState({denied: true})}>No</Button>
                </div>
              </React.Fragment>
            }
          </Paper>
        </Grid>
      </React.Fragment>
    )
  }
}

const mapDispatchToProps = {
  navigateTo: (path) => push(path)
};

export default withRouter(connect(null, mapDispatchToProps)(AgeGatePage));
